import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Explorer from "./pages/explorer";

export default () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Explorer} />
      {/* <Redirect to="/levers" /> */}
      {/* <Route path='/404' component={NotFound} />
      <Redirect to='/login' /> */}
    </Switch>
  </BrowserRouter>
);
